import t from "./index86.mjs";
import f from "./index108.mjs";
function i(o) {
  var r = f(o, "string");
  return t(r) == "symbol" ? r : r + "";
}
export {
  i as default
};
